console.log(jQuery)
$(document).ready(function () {
  changeSort();

  $(".sort__button").click(function (e) {
    e.stopPropagation();
    $(".sort__button").parent().parent().find(".dropdown").toggle();
  });

  $(document).click(function () {
    $(".sort__button").parent().parent().find(".dropdown").hide();
  });

  $(".sort__button")
    .parent()
    .parent()
    .find(".dropdown .dropdown-item")
    .click(changeSort);
});

function changeSort() {
  let new_sort = $(this).data("value");

  if (this == window) {
    let ns = window.localStorage.getItem("sort");

    if (ns) {
      new_sort = ns;
    } else {
      new_sort = "newest";
    }
  }

  let ts = new_sort.split("");
  ts[0] = ts[0].toUpperCase();
  $(".sort__button").text(ts.join(""));

  // set the latest_sort to localstorage
  window.localStorage.setItem("sort", new_sort);

  let url = new URL(window.location);

  // clear the route query params
  url.searchParams.delete("sort");

  // set new route query for params
  url.searchParams.set("sort", new_sort);

  // update the history of the url
  window.history.pushState({}, "", url);

  // update all url in the paginations
  let pagination_links = $(".desktop-view .pagination li a");
  Array.from(pagination_links).forEach((link) => {
    try {
      let p_url = new URL(link.href);
      p_url.searchParams.delete("sort");
      p_url.searchParams.set("sort", new_sort);

      link.href = p_url.href;
    } catch (e) {
      console.warn("URL: " + e.message);
    }
  });

  // hide the old sort
  hideOneSorted(new_sort);
}

function hideOneSorted(name) {
  if (window.innerWidth > 990) {
    if (name == "newest") {
      $("#newest").show();
      $("#oldest").hide();
    } else {
      $("#oldest").show();
      $("#newest").hide();
    }
  }
}
